// extracted by mini-css-extract-plugin
export default {"root":"DotsLoader_root__IWYce","dotsLoader":"DotsLoader_dotsLoader__Til9c","sk-bouncedelay":"DotsLoader_sk-bouncedelay__zLMMs"};